import React from "react";

export default function MisionYVision() {
  return (
    <div className="bg-[#e8f2f4] py-16 px-8 text-center">
      <h2 className="text-4xl font-extrabold text-[#0346a4] mb-16 drop-shadow">Misión y visión</h2>
      <div className="flex flex-col md:flex-row justify-center gap-12">
        <div className="rounded-full bg-[#e8f2f4] ml-10 w-[600px] h-96 mb-16 shadow-[0_12px_10px_rgba(0,0,0,0.25)] flex flex-col justify-between pb-5 px-10 pt-10 items-center text-center">
          <div className="flex-grow flex flex-col justify-between">
            <h3 className="text-3xl font-bold text-[#02357c] mt-0">Misión</h3>
            <p className="text-lg font-bold text-[#0054c9] my-auto">
              Facilitar el acceso, comprensión y gestión de productos financieros del mercado colombiano mediante la intermediación transparente y tecnológica, conectando a los consumidores con entidades financieras a través del modelo de finanzas abiertas. Buscamos empoderar a los usuarios para que tomen decisiones informadas, mientras fortalecemos la eficiencia comercial de las entidades aliadas.
            </p>
          </div>
        </div>
        <div className="rounded-full bg-[#e8f2f4] ml-10 w-[600px] h-96  mb-16 shadow-[0_12px_10px_rgba(0,0,0,0.25)] flex flex-col justify-between pb-5 px-10 pt-10 items-center text-center">
          <div className="flex-grow flex flex-col justify-between">
            <h3 className="text-3xl font-bold text-[#02357c] mt-0">Visión</h3>
            <p className="text-lg font-bold text-[#0054c9] my-auto">
            Ser el principal auxiliar financiero de Colombia en el ecosistema de finanzas abiertas para 2030, reconocido por su capacidad de generar valor institucional, aumentar la bancarización efectiva y construir relaciones sostenibles entre los usuarios y el sistema financiero.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
